
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Translations extends Vue {
  private translations: [string, string][] = [];

  async mounted(): Promise<void> {
    (this.$el as any).translations ??= {};

    //get external value
    this.translations = Object.entries((this.$el as any).translations ?? {});

    //make reactive
    delete (this.$el as any).translations;
    Object.defineProperty(this.$el, 'translations', {
      get: () => Object.fromEntries(this.translations),
      set: (value) => this.onExternalTranslationChange(value, Object.fromEntries(this.translations)),
    });
  }

  onExternalTranslationChange(value?: object, oldValue?: object) {
    if (JSON.stringify(value) === JSON.stringify(oldValue)) {
      return;
    }

    this.translations = Object.entries(value ?? {});
  }
}
